import React from 'react';
import * as S from './PartnerInfo.styles';

import IconSelector from '@ibibo/icon-selector';

const PartnerInfo = ({timeZone}) => {
  return (
    <S.WhyPartnerInfoBlock timeZone={timeZone}>
      <S.WhyPartnerHeadWrap timeZone={timeZone}>
        <S.WhyPartnerHeadText>Why myPartner?</S.WhyPartnerHeadText>
        <S.WhyPartnerSubText>
          Join us to discover the smart way to grow your business
        </S.WhyPartnerSubText>
      </S.WhyPartnerHeadWrap>
      {!timeZone && (
        <S.WhyPartnerInfoTileWrap timeZone={timeZone}>
          <S.WhyPartnerInfoInnerWrap>
            <S.WhyPartnerInfoTile>
              <S.WhyPartnerIconWrap>
                <IconSelector iconKey="bestRatesNew" />
              </S.WhyPartnerIconWrap>
              <S.WhyPartnerInfoTextWrap>
                <S.WhyPartnerInfoHeadText>best ever rates</S.WhyPartnerInfoHeadText>
                <S.WhyPartnerInfoSubText>Exclusive rates for our partners</S.WhyPartnerInfoSubText>
              </S.WhyPartnerInfoTextWrap>
            </S.WhyPartnerInfoTile>
            <S.WhyPartnerInfoTile>
              <S.WhyPartnerIconWrap>
                <IconSelector iconKey="expressCareNew" />
              </S.WhyPartnerIconWrap>
              <S.WhyPartnerInfoTextWrap>
                <S.WhyPartnerInfoHeadText>Express Care</S.WhyPartnerInfoHeadText>
                <S.WhyPartnerInfoSubText>
                  Easy-to-use tools for query resolutions
                </S.WhyPartnerInfoSubText>
              </S.WhyPartnerInfoTextWrap>
            </S.WhyPartnerInfoTile>
          </S.WhyPartnerInfoInnerWrap>
          <S.WhyPartnerInfoInnerWrap>
            <S.WhyPartnerInfoTile>
              <S.WhyPartnerIconWrap>
                <IconSelector iconKey="widestInventoryNew" />
              </S.WhyPartnerIconWrap>
              <S.WhyPartnerInfoTextWrap>
                <S.WhyPartnerInfoHeadText>WIDEST INVENTORY</S.WhyPartnerInfoHeadText>
                <S.WhyPartnerInfoSubText>
                  300+ Airline carriers {!timeZone ? 'and 8 lac+ hotel properties' : ''}
                </S.WhyPartnerInfoSubText>
              </S.WhyPartnerInfoTextWrap>
            </S.WhyPartnerInfoTile>
            <S.WhyPartnerInfoTile>
              <S.WhyPartnerIconWrap>
                <IconSelector iconKey="confidentialityNew" />
              </S.WhyPartnerIconWrap>
              <S.WhyPartnerInfoTextWrap>
                <S.WhyPartnerInfoHeadText>CONFIDENTIALITY ASSURED</S.WhyPartnerInfoHeadText>
                <S.WhyPartnerInfoSubText>
                  Complete confidentiality of your customer details & bookings
                </S.WhyPartnerInfoSubText>
              </S.WhyPartnerInfoTextWrap>
            </S.WhyPartnerInfoTile>
          </S.WhyPartnerInfoInnerWrap>
        </S.WhyPartnerInfoTileWrap>
      )}
      {timeZone && (
        <S.WhyPartnerInfoTileWrap timeZone={timeZone}>
          <S.WhyPartnerInfoInnerWrap timeZone={timeZone}>
            <S.WhyPartnerInfoTile timeZone={timeZone}>
              <S.WhyPartnerIconWrap>
                <IconSelector iconKey="bestRatesNew" />
              </S.WhyPartnerIconWrap>
              <S.WhyPartnerInfoTextWrap>
                <S.WhyPartnerInfoHeadText>best ever rates</S.WhyPartnerInfoHeadText>
                <S.WhyPartnerInfoSubText>Exclusive rates for our partners</S.WhyPartnerInfoSubText>
              </S.WhyPartnerInfoTextWrap>
            </S.WhyPartnerInfoTile>
            <S.WhyPartnerInfoTile timeZone={timeZone}>
              <S.WhyPartnerIconWrap>
                <IconSelector iconKey="expressCareNew" />
              </S.WhyPartnerIconWrap>
              <S.WhyPartnerInfoTextWrap>
                <S.WhyPartnerInfoHeadText>Express Care</S.WhyPartnerInfoHeadText>
                <S.WhyPartnerInfoSubText>
                  Easy-to-use tools for query resolutions
                </S.WhyPartnerInfoSubText>
              </S.WhyPartnerInfoTextWrap>
            </S.WhyPartnerInfoTile>
          </S.WhyPartnerInfoInnerWrap>
          <S.WhyPartnerInfoInnerWrap timeZone={timeZone}>
            <S.WhyPartnerInfoTile timeZone={timeZone}>
              <S.WhyPartnerIconWrap>
                <IconSelector iconKey="widestInventoryNew" />
              </S.WhyPartnerIconWrap>
              <S.WhyPartnerInfoTextWrap>
                <S.WhyPartnerInfoHeadText>WIDEST INVENTORY</S.WhyPartnerInfoHeadText>
                <S.WhyPartnerInfoSubText>
                  300+ Airline carriers {!timeZone ? 'and  8 lac+ hotel properties' : ''}
                </S.WhyPartnerInfoSubText>
              </S.WhyPartnerInfoTextWrap>
            </S.WhyPartnerInfoTile>
            <S.WhyPartnerInfoTile timeZone={timeZone}>
              <S.WhyPartnerIconWrap>
                <IconSelector iconKey="bestRatesNew" />
              </S.WhyPartnerIconWrap>
              <S.WhyPartnerInfoTextWrap>
                <S.WhyPartnerInfoHeadText>AUTOMATED ONBOARDING</S.WhyPartnerInfoHeadText>
                <S.WhyPartnerInfoSubText>
                  Quck and smooth online onboarding process
                </S.WhyPartnerInfoSubText>
              </S.WhyPartnerInfoTextWrap>
            </S.WhyPartnerInfoTile>
          </S.WhyPartnerInfoInnerWrap>
          <S.WhyPartnerInfoInnerWrap timeZone={timeZone}>
            <S.WhyPartnerInfoTile timeZone={timeZone}>
              <S.WhyPartnerIconWrap>
                <IconSelector iconKey="confidentialityNew" />
              </S.WhyPartnerIconWrap>
              <S.WhyPartnerInfoTextWrap>
                <S.WhyPartnerInfoHeadText>CONFIDENTIALITY ASSURED</S.WhyPartnerInfoHeadText>
                <S.WhyPartnerInfoSubText>
                  Complete confidentiality of your customer details & bookings
                </S.WhyPartnerInfoSubText>
              </S.WhyPartnerInfoTextWrap>
            </S.WhyPartnerInfoTile>
          </S.WhyPartnerInfoInnerWrap>
        </S.WhyPartnerInfoTileWrap>
      )}
    </S.WhyPartnerInfoBlock>
  );
};

export default PartnerInfo;
